(function exportProcessDefinition() {
    'use strict';
    angular.module('Entities')
        .service('exportProcessService', [
            'restUrlBuilder', '$injector', 'config', 'authExtend', function exportProcessService(restUrlBuilder, $injector, config, authExtend) {

                var restUrlBuilder = restUrlBuilder('wf');

                this.exportCustomerToXLS = function (filters, headers, sheetName) {
                    var params = {
                        filters: filters,
                        headers: headers,
                        sheetName: sheetName
                    };

                    return restUrlBuilder.all('exportProcess/exportcustomerxls').put(params);
                };               
            }
        ]);
})();